module.exports = __webpack_public_path__ + "img/52.3eb27f21.png";